import { PillsProps } from "../Components/MainDashboard";

/**
 * Builds a consistent filter navigation URL with all query parameters
 * Used in VehicleSlider and other components for navigate()
 */
export const buildFilterNavigateUrl = (data: PillsProps): string => {
  return `?status=${data.status}?page=${1}?perPage=${data.perPage}?statusVehicul=${
    data.statusVehicul ? data.statusVehicul : null
  }?users=${data.users ? data.users : null}?company=${
    data.company ? data.company : null
  }?locations=${data.locations ? data.locations : null}?vehicleTypes=${
    data.vehicleTypes ? data.vehicleTypes : null
  }?minPrice=${data.minPrice}?maxPrice=${
    data.maxPrice
  }?websiteIntegrations=${
    data.websiteIntegrations ? data.websiteIntegrations : "[]"
  }?statusError=${data.statusError}?tvaRecovered=${
    data.tvaRecovered
  }${data?.search ? `?search=${data?.search}` : ""}?showIncompleteVehicles=${
    data.showIncompleteVehicles
  }?purchaseType=${data.purchaseType}?sortByCreatedAt=${data.sortByCreatedAt}?physicalVehicleStatus=${
    data.physicalVehicleStatus ? data.physicalVehicleStatus : null
  }?brand=${
    data.brand ? data.brand : "[]"
  }?model=${data.model ? data.model : "[]"}?gearbox=${
    data.gearbox ? data.gearbox : "[]"
  }?bodyType=${data.bodyType ? data.bodyType : "[]"}`;
};

/**
 * Builds the API URL for fetching vehicles with all filters applied
 * Used in MainDashboard.getVehicles()
 */
export const buildVehiclesApiUrl = (
  baseUrl: string,
  filters: any
): string => {
  return `${baseUrl}/${filters.status}/${filters.page}/${filters.perPage}/${
    JSON.parse(filters.statusVehicul)?.length
      ? JSON.parse(filters.statusVehicul)
      : null
  }/${
    JSON.parse(filters.users)?.length ? JSON.parse(filters.users) : null
  }/${
    JSON.parse(filters.company)?.length ? JSON.parse(filters.company) : null
  }/${
    JSON.parse(filters.locations)?.length
      ? JSON.parse(filters.locations)
      : null
  }/${
    JSON.parse(filters.vehicleTypes)?.length
      ? JSON.parse(filters.vehicleTypes)
      : null
  }/${filters.minPrice}/${filters.maxPrice}/${filters.visible}/${
    filters.statusError
  }/${filters.tvaRecovered}/${filters.search ? filters.search : null}/${
    filters.showIncompleteVehicles
  }/${
    JSON.parse(filters.purchaseType)?.length
      ? JSON.parse(filters.purchaseType)
      : null
  }/${filters.sortByCreatedAt}/${filters.showNegativeProfit}/${
    filters?.category_id
  }/${
    filters?.physicalVehicleStatus &&
    JSON.parse(filters?.physicalVehicleStatus)?.length
      ? JSON.parse(filters?.physicalVehicleStatus)
      : null
  }/${
    filters?.websiteIntegrations &&
    JSON.parse(decodeURIComponent(filters?.websiteIntegrations))?.length
      ? JSON.parse(decodeURIComponent(filters?.websiteIntegrations))
      : null
  }/${
    filters?.brand && JSON.parse(filters?.brand)?.length
      ? JSON.parse(filters?.brand)
      : null
  }/${
    filters?.model && JSON.parse(filters?.model)?.length
      ? JSON.parse(filters?.model)
      : null
  }/${
    filters?.gearbox && JSON.parse(filters?.gearbox)?.length
      ? JSON.parse(filters?.gearbox)
      : null
  }/${
    filters?.bodyType && JSON.parse(filters?.bodyType)?.length
      ? JSON.parse(filters?.bodyType)
      : null
  }`;
};
